import React from "react";
import styles from "./style.module.scss";
import logo from "../../../../assets/images/mashie-shield-with-text-white.png";
import DeprecatedBanner from "./utils/DeprecatedBanner";
import APIVersionDropdown from "./utils/APIVersionDropdown";
import SectionDropdown from "./utils/SectionDropdown";
import EndpointsList from "./utils/EndpointsList";
import Endpoints from "./utils/Endpoints";

import GETMembers from "./members/GETMembers.json";
import GETMemberId from "./members/GETMemberId.json";
import POSTMembers from "./members/POSTMembers.json";
import PATCHMembersId from "./members/PATCHMembersId.json";
import DELETEMembersId from "./members/DELETEMembersId.json";
import POSTMembersIdMembershipRenew from "./members/POSTMembersIdMembershipRenew.json";
import POSTMembersIdRelease from "./members/POSTMembersIdRelease.json";
import DELETEMembersIdMembership from "./members/DELETEMembersIdMembership.json";
import GETMembersIdUpcomingBookings from "./members/GETMembersIdUpcomingBookings.json";
import GETMembersCanClaim from "./members/GETMembersCanClaim.json";
import POSTMembersIdClaim from "./members/POSTMembersIdClaim.json";

const specs = [
    GETMembers,
    POSTMembers,
    GETMemberId,
    PATCHMembersId,
    DELETEMembersId,
    GETMembersIdUpcomingBookings,
    DELETEMembersIdMembership,
    POSTMembersIdMembershipRenew,
    POSTMembersIdRelease,
    GETMembersCanClaim,
    POSTMembersIdClaim,
];

export default function Index() {
    return (
        <div className='app events' style={{ paddingBottom: "100px" }}>
            <div className={styles.fullHeader} alt='event'>
                <img className={styles.entityLogo} src={logo} alt='logo' />
                <h1 className={styles.headerText}>
                    Members Documentation (v2)
                </h1>
            </div>
            <div className='container'>
                <APIVersionDropdown version='v2' />
                <SectionDropdown page='members' />
                <div className='row'>
                    <div className='col-12'>
                        <h2>About this API</h2>
                        <p>
                            This API allows you to fully manage your members'
                            access to the MASHIE app, including: creating
                            members, updating member information, renewing
                            memberships, deleting members, and releasing members
                            back to MASHIE. You can also see upcoming bookings.
                        </p>
                        <div className={styles.spacer} />

                        <h2>Major updates since v1</h2>
                        <p>
                            <strong>DATA CHANGE</strong> - Some member fields
                            (eventCreditBalance, & teeTimeCreditBalance) have
                            been removed. These cannot be used to make bookings
                            via the API, so have been removed.
                        </p>
                        <br />
                        <p>
                            <strong>DATA CHANGE</strong> - Some _id's in members
                            associated data (addresses, phone numbers, & emails)
                            that cannot be used for data manipulation via our
                            API have been removed. If you required these before,
                            please generate an internal uniquie id.
                        </p>
                        <br />
                        <p>
                            <strong>FUNCTIONALITY CHANGE</strong> - When
                            creating a new member, we no longer by default send
                            the welcome email. You now need to pass an explicit
                            request should you wish us to do so.
                        </p>
                        <br />
                        <p>
                            <strong>FUNCTIONALITY CHANGE</strong> - When
                            creating a new member, we no longer by default send
                            the password reset email if you do not provide us
                            with a password. You now need to pass an explicit
                            request for us to sendWelcomeEmail should you wish
                            us to do so.
                        </p>
                        <br />
                        <p>
                            <strong>FUNCTIONALITY CHANGE</strong> - The Renew
                            membership endpoint now allows you to pass in a
                            membership key so you can renew the member with a
                            specific membership if you have more than one
                            option. This will allow you to upgrade / downgrade
                            members between tiers.
                        </p>
                        <br />
                        <p>
                            <strong>NEW API</strong> - You have a new API for
                            checking if you can claim a member from us. Before
                            trying to create a member, see if you can claim them
                            from us. If you get a 404, they either can't be
                            claimed (member already has a paid for membership
                            through us or custom membership with another
                            entity), or they were not found in our system. Try
                            and process the create at this point and see if it
                            succeeds. If the create fails at this point, you
                            will need to contact us to resolve this scenario. If
                            you get an id back, you can claim the member from us
                            instead of creating them. Run the new Claim API
                            endpoint.
                        </p>
                        <br />
                        <p>
                            <strong>NEW API</strong> - You have a new API for
                            claiming a member from us. This allows you to claim
                            a member from us if they match various criteria.
                            Please run the Can Claim API endpoint first.
                            Following a successful claim, make sure you run the
                            Cancel memberships endpoint, then Renew endpoint to
                            give them your custom membership.
                        </p>
                    </div>
                    <div className='col-12'>
                        <div className={styles.spacer} />
                        <h2>Endpoints</h2>
                        <EndpointsList specs={specs} />
                        <div className={styles.spacer} />
                        <Endpoints specs={specs} />
                    </div>
                </div>
            </div>
            <DeprecatedBanner version='v2' />
        </div>
    );
}
